/**
 * The empty thread.
 *
 * The prompts are examples of what this collaboration is FOR — planning,
 * noticing, making, and asking. They are not a menu of features; the point is
 * that anything can be typed here.
 */
export function EmptyThread({
  childName, onPick,
}: {
  childName: string
  onPick: (text: string) => void
}) {
  const prompts = [
    `Plan tomorrow for ${childName}`,
    `What has changed in the last month?`,
    `Make a counting game about dinosaurs`,
    `She won't sit still for anything today — what should I do?`,
  ]

  return (
    <div className="empty-thread">
      <div className="empty-thread-mark" aria-hidden="true">
        <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
          <defs>
            <linearGradient id="et-grad" x1="2" y1="20" x2="22" y2="4">
              <stop offset="0%" stopColor="var(--accent-teal)" />
              <stop offset="55%" stopColor="var(--accent-violet)" />
              <stop offset="100%" stopColor="var(--accent-rose)" />
            </linearGradient>
          </defs>
          <path d="M3 17c3.5-9 6.5-9 9-4.5S18.5 20 21 11"
            stroke="url(#et-grad)" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>

      <h2 className="empty-thread-title">What's on your mind?</h2>
      <p className="empty-thread-body">
        Tell me what happened, ask me to plan something, or ask me to make
        something for {childName}. I remember everything we've worked on.
      </p>

      <div className="empty-thread-prompts">
        {prompts.map((p) => (
          <button key={p} className="empty-thread-prompt" onClick={() => onPick(p)}>
            {p}
          </button>
        ))}
      </div>
    </div>
  )
}
